import { apiAboutPage } from "../../services/api/Pages";
import { useEffect, useState } from "react";

/* ================= TYPES ================= */
interface PageData {
  id: number;
  title: string;
  slug: string;
  body: string;
  image?: string;
}

/* ================= COMPONENT ================= */
const ContactUs = () => {
  const [page, setPage] = useState<PageData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await apiAboutPage("pages/contact");
        debugger;

        if (res?.data?.data) {
          setPage(res.data.data);
        } else {
          setError("Page not found");
        }
      } catch (err) {
        console.error(err);
        setError("Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="text-xl font-semibold text-blue-700 animate-pulse">
          Loading...
        </div>
      </div>
    );
  }

  /* ================= ERROR ================= */
  if (error || !page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
        <div className="bg-white shadow-lg rounded-xl px-6 py-5 text-red-600 font-semibold">
          {error || "No content available"}
        </div>
      </div>
    );
  }

  /* ================= UI ================= */
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-100 to-blue-50">
      <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden py-5 md:py-10 mt-10">
        
        {/* IMAGE */}
        {page.image && (
          <div className="w-full h-[250px] md:h-[450px] overflow-hidden">
            <img
              src={page.image}
              alt={page.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* CONTENT */}
        <div className="p-6 md:p-12">
          
          {/* TITLE */}
          <h1 className="text-3xl md:text-5xl font-bold text-center text-blue-800">
            {page.title}
          </h1>

          {/* DIVIDER */}
          <div className="w-24 h-1 bg-blue-700 mx-auto mt-5 mb-10 rounded-full"></div>

          {/* BODY */}
          <section
            className="prose prose-lg max-w-none text-gray-700 leading-relaxed prose-img:rounded-xl prose-headings:text-blue-800"
            dangerouslySetInnerHTML={{ __html: page.body }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;